<template>
  <div class="map-scale-parts">
    <span class="map-scale-parts__value">{{ mapScaleValue }}m</span>
    <div class="map-scale-parts__gauge" :style="`width: ${mapScaleGaugeWidth}px`"></div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, onUnmounted, ref } from '@vue/composition-api'
import Const from '@/util/Const'

/**
 * レース動画再生画面 GPSマップ 縮尺ゲージ コンポーネント
 */
export default defineComponent({
  name: 'MapScaleParts',
  props: {
    /**
     * GPSマップ表示倍率
     */
    mapMagnification: {
      type: Number,
      default: 1,
      required: true,
    },
  },
  setup(props) {
    /**
     * マップ 縮尺
     * 小数点以下2位まで表示: 以下切り捨て
     */
    const mapScaleValue = computed(() => Math.floor((200 / props.mapMagnification) * 100) / 100)

    /**
     * マップ 縮尺ゲージ横幅取得
     * TODO: コース別に定数を取得
     */
    const MAP_SCALE_WIDTH = Const.GPS_CIRCUIT_SCALE_GAUGE_WIDTH.SPORTSLAND_SUGO

    /**
     * マップ 縮尺ゲージ横幅取得
     */
    const mapScaleGaugeWidth = ref(0)
    const getScaleGaugeSize = () => {
      mapScaleGaugeWidth.value =
        (((document.querySelector('.race-video-gps-pane__map') as HTMLElement).clientWidth || 375) /
          375) *
        MAP_SCALE_WIDTH
    }

    onMounted(() => {
      getScaleGaugeSize()
      window.addEventListener('resize', getScaleGaugeSize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', getScaleGaugeSize)
    })
    return {
      mapScaleValue,
      mapScaleGaugeWidth,
    }
  },
})
</script>

<style lang="scss" scoped>
.map-scale-parts {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  width: calc(100vw - 32px);
  max-width: 328px;
  color: #fff;
  font-size: 10px;
  gap: 6px;

  &__gauge {
    height: 4px;
    border-width: 0 1.5px 1.5px;
    border-color: #fff;
    border-style: solid;
  }
}
</style>
